export const CHART_HEIGHT = 450;
